import React from "react";
import useTableData from "../useTableData";
import ListViewCommon from "../ListViewCommon";

const headers = [
    {"label": "Stav", "caption": "Stav"},
    {"label": "Uzavrety", "caption": "Uzavretý"},
    {"label": "Farba"}
]

function InstallationStates(props) {
    const initialFilters = []
    const baseUrl = '/installation/installations_states'
    const [data, filters, filterUpdate, links, delete_single] = useTableData(baseUrl, initialFilters, parse_links)

    function parse_links(data) {
        return data.map(entry => ({
            'Stav': `/installation_states/installation_state/${entry.id}`
        }))
    }

    function colorize() {
        const rows = document.getElementsByTagName("tr")
        const new_rows = Array.from(rows)
        new_rows.splice(0,1)
        new_rows.forEach(row => {
            const cell = row.getElementsByTagName("td")[2]
            const color = cell.innerText
            cell.style.backgroundColor = color
        })
    }

    React.useEffect(() => {
        colorize()
    }, [data])

    return (
        <ListViewCommon baseUrlFrontend={`/installation_states/installation_state`}
                        links={links}
                        headers={headers}s
                        data={data}
                        delete_single={delete_single}
                        label={"Stavy inštalácií"}
        />
    )
}

export default InstallationStates
